import api from './api';

export const userService = {
  getAll: () =>
    api.get('/User/GetAll').then(r => r.data?.data || r.data),

  getById: (id) =>
    api.get(`/User/GetById/${id}`).then(r => r.data?.data || r.data),

  update: (payload) =>
    api.put('/User/Update', payload).then(r => r.data?.data || r.data),

  updatePassword: (userId, password) =>
    api.put('/User/UpdatePassword', { userId, password }).then(r => r.data),

  delete: (id) =>
    api.delete('/User/Delete', { data: { id } }).then(r => r.data),
};
